import Yup from 'utils/validation';
import { SOURCING_EXTERNAL_INDUSTRIES } from 'modules/sourcing-external/constants/sourcingExternalIndustries';
import { SOURCING_EXTERNAL_COMPANY_SIZES } from 'modules/sourcing-external/constants/sourcingExternalCompanySizes';
import { SOURCING_EXTERNAL_YEARS_OF_EXPERIENCE } from 'modules/sourcing-external/constants/sourcingExternalYearsOfExperience';
import { SOURCING_EXTERNAL_YEARS_IN_CURRENT_ROLE } from 'modules/sourcing-external/constants/sourcingExternalYearsInCurrentRole';

export const sourcingExternalSearchFilterSchema = Yup.object({
  jobTitle: Yup.array().of(Yup.string()),
  currentTitlesOnly: Yup.boolean().required(),
  includeRelatedJobTitles: Yup.boolean(),
  excludeJobTitles: Yup.boolean(),
  jobTitleExclusions: Yup.array().of(Yup.string()),
  company: Yup.array().of(Yup.string()),
  companyFilter: Yup.string(),
  excludeCompanies: Yup.boolean(),
  companyExclusions: Yup.array().of(Yup.string()),
  keyword: Yup.string(),
  location: Yup.array().of(Yup.string()),
  skills: Yup.array().of(Yup.string()),
  industry: Yup.array().of(Yup.string().oneOf(SOURCING_EXTERNAL_INDUSTRIES)),
  yearsOfExperience: Yup.array().of(
    Yup.string().oneOf(
      SOURCING_EXTERNAL_YEARS_OF_EXPERIENCE.map(
        (experience) => experience.value
      )
    )
  ),
  yearsInCurrentRole: Yup.array().of(
    Yup.string().oneOf(
      SOURCING_EXTERNAL_YEARS_IN_CURRENT_ROLE.map(
        (experience) => experience.value
      )
    )
  ),
  companySize: Yup.array().of(
    Yup.string().oneOf(
      SOURCING_EXTERNAL_COMPANY_SIZES.map((size) => size.value)
    )
  ),
  education: Yup.array().of(Yup.string()),
  name: Yup.string()
});

export type SourcingExternalSearchFilterFormData = Yup.InferType<
  typeof sourcingExternalSearchFilterSchema
>;
